"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActions = void 0;
/**
 * Get a paginated list of actions.
---

Built-in filters `eq`, `neq`, `lt`, `lte`, `gt`, `gte`, `like`, `likeLower`, `in`, `notNull` or `isNull`

Example:
```
  ?service.id:in=1,2,3&orderBy=created_at&order=asc
```

Utilises [Objection Find](https://github.com/Vincit/objection-find).

 */
var getActions = function (instance) { return function (config) {
    return instance.get("/notifications/actions", config);
}; };
exports.getActions = getActions;
